import api from "@/api/v1-jwt/config/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  BulkInvoiceUploadEntity,
  bulkInvoiceUploadEntitySchema,
} from "../types";
import { createErrorHandler } from "@/utils/errorHandler";

type BulkInvoiceUploadParams = { userId: string; file: File };

const uploadBulkInvoiceCsv = async ({
  userId,
  file,
}: BulkInvoiceUploadParams): Promise<BulkInvoiceUploadEntity> => {
  const url = `/platform/invoices/${userId}/bulk/upload`;
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return bulkInvoiceUploadEntitySchema.parse(response.data);
};

export const bulkUploadUpload = {
  createOptions: (
    options?: UseMutationOptions<
      BulkInvoiceUploadEntity,
      Error,
      BulkInvoiceUploadParams
    >
  ) => {
    const defaultOptions: UseMutationOptions<
      BulkInvoiceUploadEntity,
      Error,
      BulkInvoiceUploadParams
    > = {
      mutationFn: uploadBulkInvoiceCsv,
      onError: createErrorHandler(),
    };
    return { ...defaultOptions, ...options };
  },
  useMutation: (
    options?: UseMutationOptions<
      BulkInvoiceUploadEntity,
      Error,
      BulkInvoiceUploadParams
    >
  ) => {
    const mutationOptions = bulkUploadUpload.createOptions(options);
    return useMutation<BulkInvoiceUploadEntity, Error, BulkInvoiceUploadParams>(
      mutationOptions
    );
  },
};
